var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.isOpen
      ? _c("div", { staticClass: "my-callback" }, [
          _c("div", { staticClass: "callback__wrapper" }, [
            _c(
              "div",
              {
                staticClass: "visual-canvas",
                staticStyle: { width: "100%", height: "100%" },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "visual-canvas__svg",
                    attrs: {
                      viewBox: [
                        "0 0 " +
                          _vm.renderSize.width +
                          " " +
                          _vm.renderSize.height,
                      ],
                      preserveAspectRatio:
                        "xMidYMid\n                     slice",
                    },
                  },
                  [
                    _c("image", {
                      attrs: {
                        x: "0",
                        y: "0",
                        width: "100%",
                        height: "100%",
                        "xlink:href": "/images/evpatoria.jpg",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      staticClass: "visual-canvas__overlay",
                      attrs: {
                        width: "100%",
                        height: "100%",
                        "fill-opacity": "0.6",
                        mask: "url(#visual-canvas__hole)",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.render.elements, function (element) {
                      return _c("path", {
                        key: element.id,
                        class: [
                          "visual-canvas__path",
                          { "is-active": _vm.selected.includes(+element.id) },
                        ],
                        attrs: { id: "1", link: element.link, d: element.path },
                        on: {
                          click: function ($event) {
                            _vm.selected.includes(+element.id)
                              ? _vm.selected.splice(
                                  _vm.selected.indexOf(+element.id),
                                  1
                                )
                              : _vm.selected.push(+element.id)
                          },
                        },
                      })
                    }),
                    _vm._v(" "),
                    _c("defs", [
                      _c(
                        "mask",
                        { attrs: { id: "visual-canvas__hole" } },
                        [
                          _c("rect", {
                            attrs: {
                              fill: "white",
                              width: "100%",
                              height: "100%",
                            },
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.render.elements, function (element) {
                            return _c("path", {
                              key: element.id,
                              attrs: { d: element.path },
                            })
                          }),
                        ],
                        2
                      ),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "close_theme_genplan",
                    on: { click: _vm.closeOpen },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button-close",
                        attrs: { "aria-label": "Закрыть генплан" },
                      },
                      [
                        _c("svg", { attrs: { viewBox: "0 0 11 11" } }, [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M5.32262 6.949L1.83262 10.439C1.49311 10.7785\n                        0.853809 10.6897 0.404706 10.2406C-0.0443966 9.79146\n                        -0.133238 9.15216 0.206274 8.81265L3.69627\n                        5.32265L0.206279 1.83266C-0.133233 1.49315\n                        -0.0443917 0.853849 0.404711 0.404746C0.853814\n                        -0.0443571 1.49311 -0.133198 1.83262 0.206314L5.32262\n                        3.69631L8.81265 0.206275C9.15216 -0.133238\n                        9.79146 -0.0443967 10.2406 0.404706C10.6897 0.853809 10.7785 1.49311 10.439 1.83262L6.94896\n                        5.32265L10.439 8.81269C10.7785 9.1522 10.6897 9.7915 10.2406 10.2406C9.79146 10.6897 9.15216\n                        10.7785 8.81265 10.439L5.32262 6.949Z",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-fade" } }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button button_theme_color button_theme_genplan button_theme_content-width",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.selectBuilding()
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.submitButton))])]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }